import {
  Component,
  Inject,
  OnInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LessonCard } from '../../../interfaces/lesson-card.interface';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import {
  MatAutocomplete,
  MatAutocompleteSelectedEvent,
} from '@angular/material/autocomplete';
import { AuthService } from '../../../services/auth.service';
import { ApiV2Service } from '../../../services/api-v2.service';
import { SpinnerService } from '../../../services/spinner.service';
import { ActivityCard } from '../../../interfaces/activity-card.interface';
import { ActivityInfo } from '../../../interfaces/activity-info.interface';

import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import { Activity } from '../../../models/activity.model';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-dialog-modify-user',
  templateUrl: './dialog-modify-user.component.html',
  styleUrls: ['./dialog-modify-user.component.css']
})
export class DialogModifyUserComponent implements OnInit {
  userInfoForm: FormGroup;
  userId: number;
  messageUserId: any;

  icons: any = {
    success: { icon: 'check_circle' },
    info: { icon: 'info' },
    danger: { icon: 'error' },
    warning: { icon: 'warning' },
    question: { icon: 'help' },
  };

constructor(
    private api: ApiV2Service,
    private spinner: SpinnerService,
    //private router: Router,
    //private route: ActivatedRoute,
    private ref: ChangeDetectorRef,
    private auth: AuthService,
    private dialogRef: MatDialogRef<DialogModifyUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.userInfoForm = new FormGroup({
      name: new FormControl(null),
      email: new FormControl(null)
    });
  }

  ngOnInit(): void {
    //console.log(this.data.messageUserId)
    this.getUserInfo()
  }

  getUserInfo() {
    this.spinner.showSpinner = true;
    this.api
      .getAlternativeService('EDIT_USER_BY_ID', this.data.messageUserId)
      .pipe(
        map((data) => {
          delete data['organizations'];
          delete data['interests'];
          delete data['biography'];
          data['isOrgAdmin'] = data['is_org_admin'];
          data['isSuperuser'] = data['is_superuser'];
          return data;
        })
      )
      .subscribe(
        (user: any) => {
          console.log(user);
          this.userInfoForm.setValue({
            name:user.name,
            email:user.email
          })
          this.spinner.showSpinner = false;
          //aca agrega el nombre del usuario creado nuevo se se debe crear un perfil
        },
        (error) => {
          console.log(error);
          this.spinner.showSpinner = false;
        }
      );
  }

  public closeMe() {
    this.dialogRef.close();
  }

}
